import { combineReducers } from 'redux';

import { ProductDetailReducerState, productDetailReducer } from '../product-detail/store/product-detail-reducer';
import { ProductListReducerState, productListReducer } from '../product-list/store/product-reducer';

export interface ProductReducerState {
    list: ProductListReducerState;
    detail: ProductDetailReducerState;
}

export const productReducer = combineReducers<ProductReducerState>({
    list: productListReducer,
    detail: productDetailReducer,
});
